import { SerializationTools } from "../serializationTools";
export const RegisterExportData = (stateManager) => {
    stateManager.exportData = (data, frame) => {
        const nodeParticleSet = data.nodeParticleSet;
        return SerializationTools.Serialize(nodeParticleSet, stateManager.data, frame);
    };
    stateManager.getEditorDataMap = () => {
        return stateManager.data.nodeParticleSet.editorData.map;
    };
};
//# sourceMappingURL=registerExportData.js.map